// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity-selector {
  display: flex;
  font-size: calc(var(--quantity-selector-height) / 2);
}
.quantity-selector > * {
  padding: 0;
}

.circle {
  width: var(--quantity-selector-height);
  height: var(--quantity-selector-height);
  cursor: pointer;
  background-color: var(--color-white);
  font-family: AppFont;
  font-size: 24px;
  line-height: normal;
  text-align: center;
  color: var(--ion-color-dark);
  border-radius: 100%;
}

.rectangle {
  color: var(--ion-color-dark);
  width: calc(1 * var(--quantity-selector-height));
  height: var(--quantity-selector-height);
  font-family: AppFontMedium;
  font-size: var(--quantity-font-size);
  line-height: 28.8px;
  text-align: center;
}

ion-icon {
  height: 100%;
  width: 100%;
}
ion-icon:active {
  opacity: 0.6;
}

.cart-screen .circle {
  background-color: var(--ion-color-gray-light);
}`, "",{"version":3,"sources":["webpack://./src/app/components/quantity-selector/quantity-selector.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,oDAAA;AACD;AACC;EACC,UAAA;AACF;;AAGA;EACC,sCAAA;EACA,uCAAA;EACA,eAAA;EACG,oCAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,4BAAA;EACH,gDAAA;EACA,uCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AADD;;AAIA;EACC,YAAA;EACA,WAAA;AADD;AAGC;EACC,YAAA;AADF;;AAUE;EACE,6CAAA;AAPJ","sourcesContent":[".quantity-selector {\n\tdisplay: flex;\n\tfont-size: calc(var(--quantity-selector-height) / 2);\n\n\t> * {\n\t\tpadding: 0;\n\t}\n}\n\n.circle {\n\twidth: var(--quantity-selector-height);\n\theight: var(--quantity-selector-height);\n\tcursor: pointer;\n    background-color: var(--color-white);\n    font-family: AppFont;\n    font-size: 24px;\n    line-height: normal;\n    text-align: center;\n    color: var(--ion-color-dark);\n    border-radius: 100%;\n}\n\n.rectangle {\n    color: var(--ion-color-dark);\n\twidth: calc(1 * var(--quantity-selector-height));\n\theight: var(--quantity-selector-height);\n\n\tfont-family: AppFontMedium;\n\tfont-size: var(--quantity-font-size);\n\tline-height: 28.8px;\n\ttext-align: center;\n}\n\nion-icon {\n\theight: 100%;\n\twidth: 100%;\n\n\t&:active {\n\t\topacity: 0.6;\n\t}\n}\n\n.cart-screen {\n\t> * {\n\t\t// background: #f1efea;\n\t}\n\n  .circle {\n    background-color: var(--ion-color-gray-light);\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
